// extracted by mini-css-extract-plugin
export default {"container":"ResetPasswordPage_container__iLv+r","ResetPasswordPage":"ResetPasswordPage_ResetPasswordPage__W-BZk"};